(function () {
  function initProductVersion() {
    const productVersions = document.querySelectorAll('.product-version');
    if (!productVersions.length) return;

    productVersions.forEach((container) => {
      const links = container.querySelectorAll('.pv-quick-link');
      const modelText = container.querySelector('.pv-label span');
      const activeLink = container.querySelector('.pv-quick-link.active');

      links.forEach((link) => {
        const href = link.getAttribute('href');
        if (!href) return;

        fetch(`${href}.js`)
          .then((response) => response.json())
          .then((data) => {
            const img = link.querySelector('img');
            if (!img || !data.featured_image) return;

            img.src = data.featured_image;
            if (data.variants?.[0]?.featured_image?.alt) {
              img.alt = data.variants[0].featured_image.alt;
            }
          })
          .catch(() => {});
      });

      if (window.screen.width > 1024 && modelText) {
        links.forEach((link) => {
          link.addEventListener('mouseenter', () => {
            const label = link.querySelector('section span');
            if (!label) return;

            const nextText = label.textContent.trim();
            if (modelText.textContent.trim() !== nextText) {
              modelText.textContent = nextText;
            }
          });
        });

        container.addEventListener('mouseleave', () => {
          setTimeout(() => {
            const activeLabel = activeLink?.querySelector('section span');
            if (!activeLabel) return;

            const activeText = activeLabel.textContent.trim();
            if (modelText.textContent.trim() !== activeText) {
              modelText.textContent = activeText;
            }
          }, 1000);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductVersion);
  } else {
    initProductVersion();
  }
})();
